export default (scopes) => {
	const normalizedScopes = [...scopes];
	return normalizedScopes;
};
